import styled from "styled-components";
import SelectAutoWidth from "../../../../../components/SelectAutoWidth";

export const Select = styled(SelectAutoWidth)`
  .ant-select-selection-search {
    padding-right: 18px;
    left: 6px !important;
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }

  .ant-select-selector {
    border: none !important;
    padding-right: 20px !important;
    padding-left: 6px !important;
  }
`;
